import { render, staticRenderFns } from "./PageComplete.vue?vue&type=template&id=1b27ca8c"
import script from "./PageComplete.vue?vue&type=script&lang=js"
export * from "./PageComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports